import { render } from "./stakingIndex.vue?vue&type=template&id=0da83a2b"
import script from "./stakingIndex.vue?vue&type=script&lang=js"
export * from "./stakingIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__